var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArticlesOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 13.909,
    viewBox: "0 0 17 13.909",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u7269\\u4EF6\\u7BA1\\u7406\\u30A2\\u30A4\\u30B3\\u30F3",
    d: "M14.692,10.192h1.159V9.033H14.692Zm0,3.3h1.159V12.336H14.692Zm0,3.284h1.159V15.62H14.692Zm-1.082,3.13V18.75h4.231V7.159H10.21V9.323L9.051,8.511V6H19V19.909ZM2,19.909V12.375L7.235,8.627l5.216,3.748v7.534H8.259V16.026H6.211v3.883ZM3.159,18.75H5.052V14.867H9.418V18.75h1.874V12.974L7.235,10.057,3.159,12.974ZM13.61,11.7ZM9.418,18.75V14.867H5.052v0H9.418Z",
    transform: "translate(-2 -6)",
    fill: "#72383D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArticlesOn);
export default __webpack_public_path__ + "static/media/icon_articles_on.6630ca410a47b723a2001ca9b0b14830.svg";
export { ForwardRef as ReactComponent };